module.exports = __webpack_public_path__ + "img/violino-cerimonia.ef889a28.jpg";